export default {
  registerPage: {
    coperation: 'DevUI Design Presented',
    title: 'Register',
    submit: 'Register',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    other: 'Already have an account?',
    resultMessage:{
      title: 'Registration success',
      content: 'Your account is successfully registered, and will return to the login page to log in.'
    },
  },
};
